import Vue from 'vue';
import Router from 'vue-router';
import $Fabric from './pages/Tools/Fabric.js';
import $ProductOrder from './pages/Tools/ProductOrder.js';

var routes = [
    {
        path: '',
        component: view('MainApp'),
        children: [
            {
                path: '/',
                component: view('Fabric/Dashboard'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles(), forbiddenRedirect: '/shirt/Dashboard'}
                },
            },
            {
                path: '/fabric/dashboard',
                name: 'fabric_dashboard',
                component: view('Fabric/Dashboard'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles() }
                },
            },
            {
                path: '/fabric/overview',
                name: 'overview',
                component: view('Fabric/Overview'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/shirt/scan/fabric/', component: view('Fabric/scan/Index'),
                children: [
                    { path: 'shirt_order', name: 'fabric_scan', component: view('Fabric/scan/ShirtOrder') },
                    { path: 'product_order', name: 'product_order', component: view('Fabric/scan/ProductOrder') },
                    { path: 'soft_and_neat', name: 'soft_and_neat', component: view('Fabric/scan/SoftAndNeat') },
                    { path: 'oem', name: 'oem', component: view('Fabric/scan/OEM') },
                    { path: 'repair', component: view('Fabric/scan/Repair') },
                    { path: 'book', component: view('Fabric/scan/Book') },
                    { path: 'sample', component: view('Fabric/scan/Sample') },
                    { path: 'c_and_c_cutting', component: view('Fabric/scan/CandC-Cutting') },
                    { path: 'fabric_cutter', component: view('Fabric/scan/FabricCutter') },
                    { path: 'damage', component: view('Fabric/scan/Damage') },
                    { path: 'return', component: view('Fabric/scan/Return') },
                    { path: 'sale', component: view('Fabric/scan/Sale') },
                    { path: 'stock_correction', component: view('Fabric/scan/StockCorrection') },
                ],
            },
            {
                path: '/fabric/listing/list_view',
                name: 'fabric_listing_list_view',
                component: view('Fabric/FabricListingListView'),
                meta: {
                    auth: { roles: [...$Fabric.getFabricSystemRoles(), ...$Fabric.getFabricInventoryRoles()] }
                },
            },
            {
                path: '/fabric/listing/inventory',
                name: 'fabric_listing_inventory',
                component: view('Fabric/FabricInventory'),
                meta: {
                    auth: {roles: [...$Fabric.getFabricSystemRoles(), ...$Fabric.getFabricInventoryRoles()] }
                },
            },
            {
                path: '/fabric/assets',
                name: 'fabric_assets',
                component: view('Fabric/FabricAssets'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/analytics',
                name: 'fabric_analytics',
                component: view('Fabric/FabricAnalytics'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/listing/grid_view',
                name: 'fabric_list',
                component: view('Fabric/FabricListingGridView'),
                meta: {
                    auth: {roles: [...$Fabric.getFabricSystemRoles(), ...$Fabric.getFabricInventoryRoles()]}
                },
            },
            {
                path: '/fabric/status/log',
                name: 'fabric_status_status_log',
                component: view('Fabric/StatusLog'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/status/log/daily',
                name: 'fabric_status_status_log_daily',
                component: view('Fabric/StatusLogDaily'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/:id/status/log',
                name: 'fabric_status_status_log_view',
                component: view('Fabric/StatusLogView'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/create/',
                name: 'fabric_create',
                component: view('Fabric/FabricCreate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/update/:id',
                name: 'fabric_update',
                component: view('Fabric/FabricUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/orders',
                name: 'fabric_orders',
                component: view('Fabric/OrderList'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/deliveries',
                name: 'fabric_deliveries',
                component: view('Fabric/OrderDeliveries'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/create',
                name: 'fabric_order_create',
                component: view('Fabric/OrderCreate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/update/:order_id',
                name: 'fabric_order_update',
                component: view('Fabric/OrderUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/:order_id/delivery/create',
                name: 'fabric_order_delivery_create',
                component: view('Fabric/DeliveryCreate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/:order_id/delivery/view',
                component: view('Fabric/DeliveryView'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/:order_id/delivery/:delivery_id/update',
                name: 'fabric_order_delivery_update',
                component: view('Fabric/DeliveryUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/order/payment_management/:order_id',
                name: 'fabric_order_payment_management',
                component: view('Fabric/PaymentManagement'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                }
            },

            {
                path: '/fabric/roll/withdraw/:fabric_id?',
                name: 'fabric_roll_withdraw',
                component: view('Fabric/RollWithdraw'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/roll/log/:fabric_id?',
                name: 'fabric_roll_roll_log',
                component: view('Fabric/RollLog'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/suppliers',
                name: 'fabric_suppliers',
                component: view('Fabric/Suppliers'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/suppliers/create',
                name: 'fabric_suppliers_create',
                component: view('Fabric/SupplierCreate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/suppliers/update/:supplier_id',
                name: 'fabric_suppliers_update',
                component: view('Fabric/SupplierUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/composition',
                name: 'fabric_composition_list',
                component: view('Fabric/CompositionLabel'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/thread_colors/:embroidery?',
                component: view('Fabric/ThreadColors'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/button_colors',
                component: view('Fabric/ButtonColors'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
          {
                path: '/fabric/interlinings',
                component: view('Fabric/Interlinings'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/fabric_families',
                component: view('Fabric/FabricFamilies'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/availability_override',
                component: view('Fabric/FabricAvailabilityOverride'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/fabric/images_review',
                component: view('Fabric/ImagesReview'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/book/list/:category',
                name: 'fabric_book_list',
                component: view('Book/BookListing'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/book/main/create/:id',
                name: 'fabric_book_create',
                component: view('Book/BookCreateUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/book/update/:id?',
                name: 'fabric_book_update',
                component: view('Book/BookCreateUpdate'),
                meta: {
                    auth: {roles: $Fabric.getFabricSystemRoles()}
                },
            },
            {
                path: '/performance_tracking/areas',
                component: view('PerformanceTracking/ByArea')
            },
            {
                path: '/performance_tracking/stations/:area?',
                component: view('PerformanceTracking/ByStation')
            },
            {
                path: '/performance_tracking/employees/:area?/:station?',
                component: view('PerformanceTracking/ByEmployee')
            },
            {
                path: '/performance_tracking/est_time_setting',
                component: view('PerformanceTracking/EstimateTimeSetting')
            },
            {
                path: '/performance_tracking/employee_level',
                component: view('PerformanceTracking/EmployeeLevel')
            },
            {
                path: '/performance_tracking/fabric_category_matchings',
                component: view('PerformanceTracking/FabricCategoryMatchings')
            },
            {
                path: '/performance_tracking/station_listings',
                component: view('PerformanceTracking/StationListings')
            },
            {
                path: '/shirt/dashboard',
                component: view('ShirtOrder/Dashboard')
            },
            {
                path: '/shirt/listings/all_shirt',
                component: view('ShirtOrder/overviews/All')
            },
            {
                path: '/shirt/listings/daily_breakdown',
                component: view('ShirtOrder/overviews/DailyBreakdown')
            },
            {
                path: '/shirt/listings/urgent/:reason',
                component: view('ShirtOrder/overviews/Urgent')
            },
            {
                path: '/shirt/listings/waiting/:reason',
                component: view('ShirtOrder/overviews/Waiting')
            },
            {
                path: '/shirt/listings/:status',
                component: view('ShirtOrder/overviews/ByStatus')
            },
            {
                path: '/shirt/repair/',
                component: view('ShirtOrder/Repair'),
                children: [
                    { path: 'start_scan', component: view('ShirtOrder/RepairScanStart') },
                    { path: 'finished_scan', component: view('ShirtOrder/RepairScanFinished') },
                    { path: 'overview', component: view('ShirtOrder/RepairOverview') },
                    { path: 'report', component: view('ShirtOrder/RepairReport') },
                ]
            },
            {
                path: '/shirt/detail/:id?',
                component: view('ShirtOrder/ShirtDetail')
            },
            {
                path: '/shirt/contact_consultant/:order_number/:id',
                component: view('ShirtOrder/ContactConsultant')
            },

            {
                path: '/shelf',
                component: view('Packaging/Shelf')
            },
            {
                path: '/shirt/scan/shelf',
                component: view('Packaging/ShelfScan')
            },
            {
                path: '/shelf/box_management',
                component: view('Packaging/ShelfBoxManagement')
            },
            {
                path: '/shirt/shipment',
                component: view('Packaging/Shipment')
            },
            {
                path: '/shirt/shipment/detail/:id',
                component: view('Packaging/ShipmentDetail')
            },

            {
                path: '/shirt/time',
                component: view('ShirtOrder/Time')
            },
            {
                path: '/shirt/cutter/overview',
                component: view('ShirtOrder/CutterOverview')
            },
            {
                path: '/shirt/scan/certificate',
                component: view('ShirtOrder/CreateCertificate')
            },
            {
                path: '/shirt/gallery',
                component: view('ShirtOrder/Gallery')
            },
            {
                path: '/login',
                name: 'login',
                component: view('Auth/Login'),
                meta: {
                    auth: false
                }
            },
            {
                path: '/settings/', component: view('Settings/Index'),
                children: [
                    { path: 'gallery_images_processor', component: view('Settings/GalleryImagesProcessor') },
                    { path: 'bulk_pattern_upload', component: view('Settings/BulkPatternUpload') }
                ]
            },
            {
                path: '/product_order', component: view('ProductOrder/Index'),
                children: [
                    { path: '/', component: view('ProductOrder/Listings') },
                    { path: 'detail/:id', component: view('ProductOrder/Detail') },
                    { path: 'scan', component: view('ProductOrder/Scan') },
                ],
            },
            {
                path: '/production_item', component: view('ProductionItem/Index'),
                children: [
                    { path: 'overview/:status/:search?', component: view('ProductionItem/Listings') },
                    { path: 'scan', component: view('ProductionItem/Scan') },
                ],
            },
            {
                path: '/product_order', component: view('ProductOrder/Index'),
                children: [
                    { path: '/', component: view('ProductOrder/Listings') },
                    { path: 'overview/:status/:search?', component: view('ProductOrder/Listings') },
                    { path: 'detail/:id', name: 'product_order_details', component: view('ProductOrder/Detail') },
                    { path: 'items', component: view('ProductOrder/IndividualItems') },
                    { path: 'scan', component: view('ProductOrder/Scan') },
                    { path: 'certificate', component: view('ProductOrder/CreateCertificate') }
                ],
            },
            { path: '/accessories/order', component: view('Accessories/Order') },
            { path: '/accounting/accounts/list', component: view('Accounting/Accounts') },
            { path: '/accounting/recipients/list', component: view('Accounting/Recipients') },
            { path: '/accounting/accounts/transactions/:id', component: view('Accounting/Transactions') },
            {
                path: '/accounting/:type/', component: view('Accounting/Index'),
                children: [
                    { path: 'invoice/list', component: view('Accounting/Invoice') },
                    { path: 'invoice/create/', component: view('Accounting/InvoiceCreate') },
                    { path: 'invoice/edit/:id', component: view('Accounting/InvoiceEdit') },
                ],
            },

            { path: '/performance_scanning/scan', component: view('PerformanceScanning/Scan') },
            { path: '/performance_scanning/download', component: view('PerformanceScanning/Download') },

            {
                path: '/performance_scanning/employees/', component: view('PerformanceScanning/EmployeesContainer'),
                children: [
                    { path: 'list', component: view('PerformanceScanning/EmployeesList') },
                    { path: 'create', component: view('PerformanceScanning/EmployeesCreate') },
                    { path: 'edit/:id', component: view('PerformanceScanning/EmployeesUpdate') }
                ],
            },
            {
              path: '/emails', component: view('Emails/EmailsList'),
              meta: {
                auth: {roles: ['admin', 'super_admin']}
              },
            },
            { path: '/emails/:id/', component: view('Emails/EmailDetail'),
              meta: {
                auth: {roles: ['admin', 'super_admin']}
              },
             }
        ],
        meta: {
            auth: true
        }
    },
    { path: "/403", component: view('403') },
    { path: "*", component: view('404') }
];

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes,
    linkExactActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

function view(template) {
    return require(`./pages/${template}.vue`).default;
}
